// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__S2zhg","checkBoxOld":"styles_checkBoxOld__3Ava9","checkBox":"styles_checkBox__rHOk9","button":"styles_button__gFqrC","inputs":"styles_inputs__3Q2ON"};